export enum LocaleEnum {
  FR = 'fr_FR',
  EN = 'en_EN',
}
